import {ref, computed} from 'vue';
import {defineStore} from 'pinia';

export const useLoaderStore = defineStore('loader', () => {
    const _isLoaderActive = ref(false);

    const isActive = computed(() => _isLoaderActive.value);

    function show() {
        _isLoaderActive.value = true;
    }

    function hide() {
        _isLoaderActive.value = false;
    }

    return {
        isActive,
        show,
        hide,
    };
});
